import { render, staticRenderFns } from "./resultModal.vue?vue&type=template&id=46e0fe16&scoped=true"
import script from "./resultModal.vue?vue&type=script&lang=js"
export * from "./resultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0fe16",
  null
  
)

export default component.exports